import React, { useState, useRef } from "react";
import classNames from "classnames";
import FullScreen from "edu_lms_v2/components/FullScreen";
import { Image } from "..";
import styles from "./styles.module.scss";

const ImageWithFullScreen = ({
  src,
  alt = "image with full screen",
  hasFullScreen,
}) => {
  const refImgWrapper = useRef();
  const [isFullScreen, setIsFullScreen] = useState(false);

  if (!src) return null;

  if (hasFullScreen) {
    return (
      <div
        className={classNames(styles["image-fullscreen__wrapper"], {
          "mw-100 mh-100": isFullScreen,
        })}
        ref={refImgWrapper}
      >
        <Image
          src={src}
          alt={alt}
          className={classNames({
            "image-question-exercise": !isFullScreen,
            "image-question-exercise-full": isFullScreen,
          })}
        />
        <FullScreen
          ref={refImgWrapper}
          isFullScreen={isFullScreen}
          setIsFullScreen={setIsFullScreen}
        />
      </div>
    );
  }

  return <Image src={src} alt={alt} />;
};

export default ImageWithFullScreen;
